import React, { ReactElement, useEffect } from 'react';
import Breadcrumbs from 'components/atoms/Breadcrumbs';
import { StyledPageTitle } from 'theme/styles';
import { isAccountLoggedIn } from 'requests/account';
import { ERouteLinks } from 'models/route';
import { Grid, Typography } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { useForm } from 'react-hook-form';
import { FormInput } from 'components/molecules/FormInput';
import { SessionStorageKeys } from 'constants/Storage';
import { DashboardQuickPreview } from './DashboardQuickPreview';
import { DashboardBeforeYouApply } from './DashboardBeforeYouApply';
import { DashboardApplyforLicence } from './DashboardApplyforLicence';
import { DashboardKeepUpdated } from './DashboardKeepUpdated';
import { DashboardAdditionalGuidance } from './DashboardAdditionalGuidance';
import { DashboardGeneralEnquiries } from './DashboardGeneralEnquiries';

const DashboardPage = (): ReactElement => {
  const navigate = useNavigate();

  useEffect(() => {
    isAccountLoggedIn(() =>
      navigate(ERouteLinks.Auth, {
        state: { type: window.sessionStorage.getItem(SessionStorageKeys.type) },
      }),
    );
  }, []);

  const {
    control,
    handleSubmit,
    setValue,
    formState: { errors },
  } = useForm<any>({});

  const onSubmitForm = () => {};

  return (
    <>
      <Breadcrumbs items={['Dashboard']} />
      <StyledPageTitle variant="h4">Welcome John Smith,</StyledPageTitle>

      <Typography variant="subtitle1">
        Welcome to the dashboard. You can find guidance on firearms, explosives, explosive
        precursors and poisons licensing, as well as apply for and manage your applications and
        licences.
      </Typography>

      <form onSubmit={handleSubmit(onSubmitForm)}>
        <Grid item container xs={12} mt="32px" mb="80px">
          <Grid item xs={6}>
            <FormInput
              name="search"
              control={control}
              errors={errors}
              setValue={setValue}
              onClickSearch={() => {}}
              sx={{ borderColor: 'red' }}
            />
          </Grid>
        </Grid>
      </form>

      <Grid container gap="40px">
        <DashboardQuickPreview />
        <DashboardBeforeYouApply />
        <DashboardApplyforLicence />
        <DashboardKeepUpdated />
        <DashboardAdditionalGuidance />
        <DashboardGeneralEnquiries />
      </Grid>
    </>
  );
};
export { DashboardPage };
